import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOptionalAppSession } from '../hooks/AppSessionContext';
import { useGamification } from '../hooks/GamificationContext';
import tapReactionArt from '../assets/tavern/zapfhahn-reaction.jpg';

const TAVERN_VIDEO_URL = 'https://app.pfandpirat.com/wp-content/uploads/taverne.mp4';
const TAVERN_SOUND_URL = 'https://app.pfandpirat.com/wp-content/uploads/Tavern-Song.mp3';
const DRINKS_TOP_URL = '/wp-json/pfandpirat/v1/drinks/top?limit=50';
const DRINKS_SEARCH_URL = '/wp-json/pfandpirat/v1/drinks?search=limonade';
const TAVERN_STATUS_URL = window?.pfandpiratData?.tavernStatusApiUrl || '/wp-json/pfandpirat/v1/tavern/status';
const TAVERN_LEADERBOARD_URL = window?.pfandpiratData?.tavernLeaderboardApiUrl || '/wp-json/pfandpirat/v1/tavern/leaderboard';
const TAVERN_REWARD_URL = window?.pfandpiratData?.tavernRewardApiUrl || '/wp-json/pfandpirat/v1/tavern/reward';
const SESSION_LENGTH = 10;
const MEMORY_PAIR_COUNT = 8;
const TAP_REACTION_ROUNDS = 5;
const TAP_TARGET_PERCENT = 82;
const TAP_OVERFLOW_PERCENT = 104;
const COUNTER_TIMING_ROUNDS = 10;
const COUNTER_TIMING_MISS_POSITION = 106;
const MEMORY_CARD_BASE_URL = 'https://app.pfandpirat.com/wp-content/uploads/';
const MEMORY_CARD_FILES = [
  'paar-01-pfandpirat-loot-001-alter-kronkorken.avif',
  'paar-02-pfandpirat-loot-002-verlorener-pfandbon.avif',
  'paar-03-pfandpirat-loot-003-goldene-pfandmarke.avif',
  'paar-04-pfandpirat-loot-004-zerbeulte-energydose.avif',
  'paar-05-pfandpirat-loot-005-versiegelte-schatzkarte.avif',
  'paar-06-pfandpirat-loot-006-funkelnder-glasfund.avif',
  'paar-07-pfandpirat-loot-007-kapitaens-flaschenoeffner.avif',
  'paar-08-pfandpirat-loot-008-glitzernder-dosenring.avif',
  'paar-09-pfandpirat-loot-009-vergessener-einkaufschip.avif',
  'paar-10-pfandpirat-loot-010-mystische-leergutmarke.avif',
  'paar-11-pfandpirat-loot-011-kistenkompass.avif',
  'paar-12-pfandpirat-loot-012-silberne-pfandmuenze.avif',
  'paar-13-pfandpirat-loot-013-rostiger-ankerhaken.avif',
  'paar-14-pfandpirat-loot-014-flaschengeist-siegel.avif',
  'paar-15-pfandpirat-loot-015-goldstaub-im-beutel.avif',
  'paar-16-pfandpirat-loot-016-zerfetzte-crew-flagge.avif',
  'paar-17-pfandpirat-loot-017-piratenpfiff.avif',
  'paar-18-pfandpirat-loot-018-schimmernde-dosenlasche.avif',
  'paar-19-pfandpirat-loot-019-muschel-mit-pfandsiegel.avif',
  'paar-20-pfandpirat-loot-020-kaputte-schatztruhe.avif',
  'paar-21-pfandpirat-loot-021-blauer-flaschensplitter.avif',
  'paar-22-pfandpirat-loot-022-kompassnadel-des-sammlers.avif',
  'paar-23-pfandpirat-loot-023-goldener-schraubverschluss.avif',
  'paar-24-pfandpirat-loot-024-pfandpiraten-amulett.avif',
  'paar-25-pfandpirat-loot-025-alte-supermarktmarke.avif',
  'paar-26-pfandpirat-loot-026-gluehender-barcode.avif',
  'paar-27-pfandpirat-loot-027-schatzkisten-scharnier.avif',
  'paar-28-pfandpirat-loot-028-geheime-fundnotiz.avif',
  'paar-29-pfandpirat-loot-029-meeresgruener-pfandkristall.avif',
  'paar-30-pfandpirat-loot-030-krone-des-leergutkoenigs.avif',
  'paar-31-pfandpirat-fund-031-kleine-pet-flasche.avif',
  'paar-32-pfandpirat-fund-032-grosse-pet-flasche.avif',
  'paar-33-pfandpirat-fund-033-energy-fund.avif',
  'paar-34-pfandpirat-fund-034-glasflasche-aus-der-bucht.avif',
  'paar-35-pfandpirat-fund-035-mate-aus-dem-nebel.avif',
  'paar-36-pfandpirat-fund-036-cola-der-crew.avif',
  'paar-37-pfandpirat-fund-037-premium-pfandflasche.avif',
  'paar-38-pfandpirat-fund-038-verborgene-mehrwegperle.avif',
  'paar-39-pfandpirat-fund-039-piraten-limo.avif',
  'paar-40-pfandpirat-fund-040-legendaerer-leergutfund.avif',
  'paar-41-pfandpirat-avatar-041-anfaenger-pirat.avif',
  'paar-42-pfandpirat-avatar-042-flaschenjaeger.avif',
  'paar-43-pfandpirat-avatar-043-dosenmatrose.avif',
  'paar-44-pfandpirat-avatar-044-schatzsucher.avif',
  'paar-45-pfandpirat-avatar-045-hafenadmiral.avif',
  'paar-46-pfandpirat-avatar-046-leergutlegende.avif',
  'paar-47-pfandpirat-event-047-parkfund.avif',
  'paar-48-pfandpirat-event-048-supermarkt-raid.avif',
  'paar-49-pfandpirat-event-049-nacht-expedition.avif',
  'paar-50-pfandpirat-event-050-hafensturm.avif',
  'paar-51-pfandpirat-event-051-goldene-route.avif',
  'paar-52-pfandpirat-spezial-052-xp-boost.avif',
  'paar-53-pfandpirat-spezial-053-doppelte-beute.avif',
  'paar-54-pfandpirat-spezial-054-crew-bonus.avif',
  'paar-55-pfandpirat-spezial-055-schatzkarten-joker.avif',
];

const GAME_TABLES = [
  {
    key: 'logo-quiz',
    title: 'Logo-Quiz',
    label: 'Marken erkennen',
    description: 'Errate Getränke anhand verdeckter Logos, Etikett-Ausschnitte oder Silhouetten.',
    state: 'Spielbar',
    meta: 'Skill-Spiel',
  },
  {
    key: 'deposit-guess',
    title: 'Pfandmeister',
    label: 'Pfandart schätzen',
    description: 'Entscheide, ob ein Getränk Einweg, Mehrweg oder ohne Pfand ist.',
    state: 'Spielbar',
    meta: 'Wissensrunde',
  },
  {
    key: 'bottle-shadow',
    title: 'Flaschenschatten',
    label: 'Bild erkennen',
    description: 'Erkenne Produkte aus der Getränkedatenbank nur anhand von Form und Farbe.',
    state: 'Spielbar',
    meta: 'Bilderrätsel',
  },
  {
    key: 'memory',
    title: 'Karten-Memory',
    label: '55 Motive paaren',
    description: 'Decke gleiche Pfandpirat-Karten auf und finde acht Paare.',
    state: 'Neu',
    meta: 'Merkspiel',
  },
  {
    key: 'tap-reaction',
    title: 'Zapfhahn-Reaktion',
    label: 'Punktgenau zapfen',
    description: 'Stoppe den Zapfhahn kurz vor der Linie. Je näher am Ziel, desto mehr Punkte.',
    state: 'Neu',
    meta: 'Reaktionsspiel',
  },
  {
    key: 'counter-timing',
    title: 'Tresen-Timing',
    label: 'Getränke sortieren',
    description: 'Fange rutschende Getränke ab und ziehe sie in den passenden Eimer, Korb oder die richtige Kiste.',
    state: 'Neu',
    meta: 'Sortier-Arcade',
  },
];

const COUNTER_TIMING_BINS = [
  { key: 'Einweg', title: 'Einweg-Eimer', hint: '0,25 EUR', tone: 'single' },
  { key: 'Mehrweg', title: 'Mehrweg-Kiste', hint: '0,08 bis 0,15 EUR', tone: 'returnable' },
  { key: 'Kein Pfand', title: 'Pfandfrei-Korb', hint: '0,00 EUR', tone: 'free' },
];

const COUNTER_TIMING_TARGETS = COUNTER_TIMING_BINS.map((bin) => bin.key);

const TAVERN_LEVELS = [
  { level: 1, name: 'Wirtsstube', minRounds: 0 },
  { level: 2, name: 'Stammrunde', minRounds: 2 },
  { level: 3, name: 'Volle Schenke', minRounds: 8 },
  { level: 4, name: 'Hafenliebling', minRounds: 20 },
  { level: 5, name: 'Tavernenlegende', minRounds: 50 },
];

const FALLBACK_DRINKS = [
  { id: 'fallback-spezi', product_name: 'Spezi 0,5 l EINWEG', volume: '0,5', pfand_info: '0,25 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-cola', product_name: 'Cola 0,5 l EINWEG', volume: '0,5', pfand_info: '0,25 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-wasser', product_name: 'Mineralwasser 1,0 l MEHRWEG', volume: '1,0', pfand_info: '0,15 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-saft', product_name: 'Apfelsaft MEHRWEG', volume: '0,7', pfand_info: '0,15 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-bier', product_name: 'Malzgetränk MEHRWEG', volume: '0,5', pfand_info: '0,08 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-dose', product_name: 'Energy Dose EINWEG', volume: '0,33', pfand_info: '0,25 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-tee', product_name: 'Eistee Dose EINWEG', volume: '0,33', pfand_info: '0,25 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-wein', product_name: 'Traubensaft KEIN PFAND', volume: '0,75', pfand_info: '0,00 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-limo', product_name: 'Limonade 1,0 l MEHRWEG', volume: '1,0', pfand_info: '0,15 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
  { id: 'fallback-orange', product_name: 'Orangenlimonade 0,5 l EINWEG', volume: '0,5', pfand_info: '0,25 EUR', image_url: 'https://app.pfandpirat.com/wp-content/uploads/pfandpirat.png' },
];

function getDisplayName(session) {
  return (
    session?.user?.display_name
    || session?.user?.name
    || window?.pfandpiratData?.display_name
    || 'Freibeuter'
  );
}

function normalizeTavernStatus(payload) {
  const source = payload && typeof payload === 'object' ? payload : {};
  const normalizeRow = (row) => ({
    rounds: Number(row?.rounds || 0),
    total_count: Number(row?.total_count || 0),
    correct_count: Number(row?.correct_count || 0),
    last_played_at: row?.last_played_at || '',
  });

  return {
    all_time: normalizeRow(source.all_time),
    today: normalizeRow(source.today),
  };
}

function getTavernLevel(roundCount) {
  const safeRoundCount = Math.max(0, Number(roundCount || 0));
  return [...TAVERN_LEVELS]
    .reverse()
    .find((level) => safeRoundCount >= level.minRounds) || TAVERN_LEVELS[0];
}

function formatRoundCount(count) {
  const safeCount = Math.max(0, Number(count || 0));
  return `${safeCount} ${safeCount === 1 ? 'Runde' : 'Runden'}`;
}

function getLocalDateKey() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

function getTavernDailyStorageKey(session) {
  const userKey = session?.user?.id || session?.user?.ID || session?.user?.user_login || window?.pfandpiratData?.user_id || 'guest';
  return `pfandpirat:tavern:daily:${userKey}`;
}

function loadTavernDailyState(storageKey) {
  if (typeof window === 'undefined' || !storageKey) return null;

  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    if (!parsed || parsed.date !== getLocalDateKey()) return null;
    return parsed;
  } catch (error) {
    return null;
  }
}

function saveTavernDailyState(storageKey, patch) {
  if (typeof window === 'undefined' || !storageKey) return;

  try {
    window.localStorage.setItem(storageKey, JSON.stringify({
      date: getLocalDateKey(),
      ...patch,
    }));
  } catch (error) {}
}

function normalizeTavernLeaderboard(payload) {
  const items = Array.isArray(payload?.items) ? payload.items : [];
  return items.map((item) => ({
    rank: Number(item?.rank || 0),
    user_id: Number(item?.user_id || 0),
    is_me: Boolean(item?.is_me),
    display_name: item?.display_name || item?.username || 'Pfandpirat',
    user_login: item?.user_login || item?.username || '',
    user_nicename: item?.user_nicename || item?.user_login || item?.username || '',
    avatar_url: item?.avatar_url || '',
    score: Number(item?.score || item?.best_percent || 0),
    best_correct: Number(item?.best_correct || 0),
    best_total: Number(item?.best_total || 0),
    rounds: Number(item?.rounds || 0),
    tavern_ruf: item?.tavern_ruf || null,
    gamification_rank: item?.gamification_rank || null,
  }));
}

function getTavernProfileHref(item) {
  if (item?.is_me) return '#/profile';
  const slug = item?.user_nicename || item?.user_login || '';
  return slug ? `#/profil/${encodeURIComponent(slug)}` : null;
}

function getDrinkName(drink) {
  return drink?.product_name || drink?.name || drink?.title || drink?.title?.rendered || 'Unbekanntes Getränk';
}

function cleanDrinkTitle(value) {
  return String(value || 'Unbekanntes Getränk')
    .replace(/\b(?:EINWEG|MEHRWEG|KEIN\s+PFAND|OHNE\s+PFAND|PFANDFREI)\b/gi, '')
    .replace(/\s*[-|/]\s*$/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim() || 'Unbekanntes Getränk';
}

function getDrinkImage(drink) {
  return (
    drink?.image_url
    || drink?.thumbnail
    || drink?.featured_media_url
    || drink?.media_url
    || drink?.image
    || drink?._embedded?.['wp:featuredmedia']?.[0]?.media_details?.sizes?.medium?.source_url
    || drink?._embedded?.['wp:featuredmedia']?.[0]?.source_url
    || ''
  );
}

function getDrinkPfand(drink) {
  return drink?.pfand_info || drink?.deposit_info || drink?.acf?.pfand_info || '';
}

function normalizeDrink(raw, index) {
  const rawName = getDrinkName(raw);
  return {
    id: raw?.source_id || raw?.id || raw?.ean_code || raw?.barcode || `drink-${index}`,
    rawName,
    name: cleanDrinkTitle(rawName),
    image: getDrinkImage(raw),
    volume: raw?.volume ?? raw?.amount ?? raw?.size ?? raw?.acf?.volume ?? '',
    pfand: getDrinkPfand(raw),
  };
}

function normalizeDepositAnswer(drink) {
  const text = `${drink?.rawName || drink?.name || ''} ${drink?.pfand || ''}`.replace(',', '.').toLowerCase();
  if (/\b(kein\s+pfand|ohne\s+pfand|pfandfrei)\b/.test(text) || /0\.00/.test(text)) return 'Kein Pfand';
  if (/\beinweg\b/.test(text)) return 'Einweg';
  if (/\bmehrweg\b/.test(text)) return 'Mehrweg';
  const match = text.match(/0\.\d{1,2}/);
  if (!match) return 'Unklar / offen';
  const number = Number(match[0]);
  if (number >= 0.24) return 'Einweg';
  if (number >= 0.07) return 'Mehrweg';
  return 'Kein Pfand';
}

function getCounterDrinkVisual(drink) {
  const text = `${drink?.rawName || ''} ${drink?.name || ''}`.toLowerCase();
  if (/\b(dose|can|energy)\b/.test(text)) return 'can';
  if (/\b(saft|tee|nektar|karton)\b/.test(text)) return 'carton';
  return 'bottle';
}

function shuffle(items) {
  return [...items].sort(() => Math.random() - 0.5);
}

function formatMemoryTitle(slug) {
  const replacements = {
    anfaenger: 'Anfänger',
    grosse: 'Große',
    kapitaens: 'Kapitäns',
    flaschenoeffner: 'Flaschenöffner',
    pfandmuenze: 'Pfandmünze',
    gluehender: 'Glühender',
    meeresgruener: 'Meeresgrüner',
    legendaerer: 'Legendärer',
    leergutkoenigs: 'Leergutkönigs',
  };

  return String(slug || 'Pfandpirat Karte')
    .split('-')
    .map((part) => replacements[part] || `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(' ');
}

function normalizeMemoryCard(fileName, index) {
  const stem = fileName.replace(/\.avif$/i, '');
  const match = stem.match(/^paar-(\d+)-pfandpirat-([a-z]+)-(\d+)-(.+)$/);
  const pairNumber = match?.[1] || String(index + 1).padStart(2, '0');
  const type = match?.[2] || 'loot';
  const typeLabels = {
    loot: 'Loot',
    fund: 'Fund',
    avatar: 'Crew',
    event: 'Event',
    spezial: 'Spezial',
  };

  return {
    id: `memory-${pairNumber}`,
    pairNumber,
    type,
    typeLabel: typeLabels[type] || 'Karte',
    title: formatMemoryTitle(match?.[4] || stem),
    image: `${MEMORY_CARD_BASE_URL}${fileName}`,
  };
}

const MEMORY_CARDS = MEMORY_CARD_FILES.map(normalizeMemoryCard);

function buildMemoryDeck(cards, pairCount = MEMORY_PAIR_COUNT) {
  const roundId = Math.random().toString(36).slice(2, 9);
  const selectedCards = shuffle(cards).slice(0, pairCount);
  return shuffle(selectedCards.flatMap((card) => (
    ['a', 'b'].map((copy) => ({
      ...card,
      id: `${card.id}-${copy}-${roundId}`,
      pairId: card.id,
      copy,
    }))
  )));
}

function buildOptions(drinks, correct, mode) {
  if (mode === 'deposit-guess') {
    return shuffle(['Einweg', 'Mehrweg', 'Kein Pfand', 'Unklar / offen']);
  }

  const names = drinks
    .filter((drink) => drink.id !== correct.id && drink.name !== correct.name)
    .map((drink) => drink.name);
  return shuffle([correct.name, ...shuffle(names).slice(0, 3)]);
}

function buildQuestion(mode, drinks) {
  const correct = drinks.find((drink) => drink.name && (mode === 'deposit-guess' || drink.image));
  if (!correct) return null;

  const answer = mode === 'deposit-guess' ? normalizeDepositAnswer(correct) : correct.name;
  return {
    id: `${mode}-${correct.id}-${Date.now()}`,
    mode,
    correct,
    answer,
    options: buildOptions(drinks, correct, mode),
  };
}

function buildQuestionSet(mode, drinks) {
  const pool = shuffle(drinks.filter((drink) => drink.name && (mode === 'deposit-guess' || drink.image)));
  if (!pool.length) return [];

  const picked = [];
  while (picked.length < SESSION_LENGTH) {
    const source = pool[picked.length % pool.length];
    picked.push({ ...source, sessionPickId: `${source.id}-${picked.length}` });
  }

  return picked.map((drink, index) => ({
    ...buildQuestion(mode, [drink, ...pool.filter((item) => item.id !== drink.id)]),
    number: index + 1,
  })).filter(Boolean);
}

function buildCounterTimingItems(drinks, count = COUNTER_TIMING_ROUNDS) {
  const fallbackDrinks = FALLBACK_DRINKS.map(normalizeDrink);
  const sourceDrinks = drinks?.length ? drinks : fallbackDrinks;
  const eligibleDrinks = sourceDrinks.filter((drink) => (
    drink.name && COUNTER_TIMING_TARGETS.includes(normalizeDepositAnswer(drink))
  ));
  const pool = shuffle(eligibleDrinks.length ? eligibleDrinks : fallbackDrinks);
  const roundId = Math.random().toString(36).slice(2, 9);

  return Array.from({ length: count }, (_, index) => {
    const drink = pool[index % pool.length];
    return {
      id: `counter-${roundId}-${drink.id}-${index}`,
      name: drink.name,
      image: drink.image,
      volume: drink.volume,
      target: normalizeDepositAnswer(drink),
      visual: getCounterDrinkVisual(drink),
      lane: index % 3,
    };
  });
}

function resultText(isCorrect, answer) {
  if (isCorrect) return 'Richtig. Der Wirt nickt anerkennend.';
  return `Knapp vorbei. Richtig wäre: ${answer}.`;
}

function buildRewardSummary(correct, total = SESSION_LENGTH) {
  const safeCorrect = Math.max(0, Math.min(total, Number(correct || 0)));
  const percent = Math.round((safeCorrect / total) * 100);
  const xp = 5 + (safeCorrect * 2) + (safeCorrect === total ? 10 : 0);
  const bronze = percent >= 100 ? 50 : percent >= 80 ? 25 : percent >= 50 ? 10 : 0;
  let title = 'Runde abgeschlossen';
  if (percent >= 90) title = 'Glanzrunde am Tresen';
  else if (percent >= 70) title = 'Starke Tavernenrunde';
  else if (percent >= 50) title = 'Solide Runde';

  return {
    correct: safeCorrect,
    total,
    percent,
    title,
    xp,
    bronze,
    bronzeLabel: bronze > 0 ? `+${bronze} Bronze` : 'keine Münzen',
    couponLabel: percent === 100 ? 'Coupon vorbereitet' : 'kein Coupon',
    couponAwarded: false,
  };
}

function getTapReactionScore(fillPercent) {
  const fill = Number(fillPercent || 0);
  const overflowed = fill >= 100;
  const distance = Math.abs(fill - TAP_TARGET_PERCENT);
  const points = overflowed ? 0 : Math.max(0, Math.round(100 - (distance * 5)));
  let title = 'Solider Ausschank';
  let text = 'Der Krug ist brauchbar gefüllt.';

  if (overflowed) {
    title = 'Überschäumt';
    text = 'Der Wirt wischt schon den Tresen.';
  } else if (distance <= 1.5) {
    title = 'Perfekt gezapft';
    text = 'Direkt auf der Linie. Das gibt Applaus am Tresen.';
  } else if (distance <= 5) {
    title = 'Sehr nah dran';
    text = 'Ein sauberer Stopp, nur einen Schluck daneben.';
  } else if (fill < TAP_TARGET_PERCENT) {
    title = 'Zu früh gestoppt';
    text = 'Da hätte noch ein ordentlicher Schluck hineingepasst.';
  } else {
    title = 'Etwas zu mutig';
    text = 'Kurz vor knapp, aber die Schaumkrone steigt.';
  }

  return {
    fill,
    distance,
    overflowed,
    points,
    title,
    text,
  };
}

function getTapRewardCorrectCount(scores) {
  const totalPoints = scores.reduce((sum, value) => sum + Number(value || 0), 0);
  return Math.max(0, Math.min(TAP_REACTION_ROUNDS, Math.round(totalPoints / 100)));
}

function CounterDrinkSprite({ visual = 'bottle', image = '', name = '' }) {
  if (image) {
    return (
      <span className="pfp-tavern-counter-drink__image">
        <img src={image} alt="" loading="eager" draggable="false" />
      </span>
    );
  }

  if (visual === 'can') {
    return (
      <svg viewBox="0 0 92 120" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="pfpCounterCan" x1="0" x2="1">
            <stop offset="0" stopColor="#e7f7ff" />
            <stop offset="0.46" stopColor="#3db0d7" />
            <stop offset="1" stopColor="#0b5f86" />
          </linearGradient>
        </defs>
        <ellipse cx="46" cy="16" rx="30" ry="10" fill="#dff4ff" />
        <path d="M16 17h60v86c0 6-13 11-30 11s-30-5-30-11V17z" fill="url(#pfpCounterCan)" />
        <ellipse cx="46" cy="103" rx="30" ry="11" fill="#0a4e70" opacity="0.86" />
        <path d="M29 35h34v45H29z" rx="6" fill="#fff8df" opacity="0.95" />
        <path d="M36 20c5 3 15 3 20 0" fill="none" stroke="#6a8798" strokeWidth="4" strokeLinecap="round" />
        <path d="M24 28c7 5 13 12 17 20" fill="none" stroke="#ffffff" strokeWidth="4" opacity="0.45" strokeLinecap="round" />
      </svg>
    );
  }

  if (visual === 'carton') {
    return (
      <svg viewBox="0 0 92 120" aria-hidden="true" focusable="false">
        <path d="M22 24 38 8h33v98c0 6-5 10-11 10H31c-6 0-11-4-11-10V31c0-3 1-5 2-7z" fill="#f5d36d" />
        <path d="M38 8v25H20l18-25z" fill="#fff0b3" />
        <path d="M38 33h33v73c0 6-5 10-11 10H38V33z" fill="#e69c35" />
        <path d="M31 49h30v34H31z" rx="5" fill="#fff8df" />
        <path d="M33 96h26" stroke="#855015" strokeWidth="5" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 92 120" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="pfpCounterBottle" x1="0" x2="1">
          <stop offset="0" stopColor="#effbff" />
          <stop offset="0.42" stopColor="#77d0e6" />
          <stop offset="1" stopColor="#177d96" />
        </linearGradient>
      </defs>
      <path d="M38 8h16v23c0 7 17 18 17 35v36c0 8-7 14-15 14H36c-8 0-15-6-15-14V66c0-17 17-28 17-35V8z" fill="url(#pfpCounterBottle)" />
      <path d="M36 4h20v11H36z" rx="3" fill="#d99a2d" />
      <path d="M31 58h30v32H31z" rx="7" fill="#fff8df" opacity="0.96" />
      <path d="M31 31c-3 8-9 15-9 29v38c0 8 6 15 15 15" fill="none" stroke="#fff" strokeWidth="5" opacity="0.38" strokeLinecap="round" />
    </svg>
  );
}

function CounterBinIcon({ tone }) {
  if (tone === 'returnable') {
    return (
      <svg viewBox="0 0 96 76" aria-hidden="true" focusable="false">
        <path d="M11 20h74l-6 44H17L11 20z" fill="#9a5b20" />
        <path d="M17 14h62v15H17z" fill="#c27a31" />
        <path d="M23 31h12v22H23zm19 0h12v22H42zm19 0h12v22H61z" fill="#5f3515" opacity="0.66" />
        <path d="M18 21h60M24 64h48" stroke="#f0c37a" strokeWidth="4" strokeLinecap="round" opacity="0.72" />
      </svg>
    );
  }

  if (tone === 'free') {
    return (
      <svg viewBox="0 0 96 76" aria-hidden="true" focusable="false">
        <path d="M22 26h52l-7 38H29L22 26z" fill="#d7a24b" />
        <path d="M28 26c2-10 9-16 20-16s18 6 20 16" fill="none" stroke="#8a5c12" strokeWidth="7" strokeLinecap="round" />
        <path d="M31 36h34M34 47h28M37 58h22" stroke="#fff1c8" strokeWidth="4" strokeLinecap="round" opacity="0.7" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 96 76" aria-hidden="true" focusable="false">
      <path d="M23 18h50l-5 45c-1 6-6 10-12 10H40c-6 0-11-4-12-10L23 18z" fill="#298fbd" />
      <path d="M18 14h60v10H18z" rx="5" fill="#0b5f86" />
      <path d="M35 14c1-9 6-13 13-13s12 4 13 13" fill="none" stroke="#0b5f86" strokeWidth="6" strokeLinecap="round" />
      <path d="M35 32h26M38 45h20M41 58h14" stroke="#dff4ff" strokeWidth="4" strokeLinecap="round" opacity="0.78" />
    </svg>
  );
}

function makeSessionKey(gameKey) {
  const randomPart = Math.random().toString(36).slice(2, 10);
  return `${gameKey}-${Date.now()}-${randomPart}`;
}

function createIdleCounterGame() {
  return {
    status: 'idle',
    items: [],
    index: 0,
    position: 0,
    score: 0,
    misses: 0,
    streak: 0,
    lastResult: null,
    dragPoint: null,
  };
}

function scrollElementIntoView(element, behavior = 'smooth') {
  if (!element) return;

  try {
    element.scrollIntoView({ behavior, block: 'start', inline: 'nearest' });
  } catch (error) {
    try {
      element.scrollIntoView(true);
    } catch {}
  }
}

export default function TavernPage() {
  const navigate = useNavigate();
  const sessionContext = useOptionalAppSession();
  const session = sessionContext?.session || null;
  const mergeSessionPatch = sessionContext?.mergeSessionPatch;
  const displayName = getDisplayName(session);
  const dailyStorageKey = getTavernDailyStorageKey(session);
  const { applyGamificationPayload } = useGamification() || {};
  const audioRef = useRef(null);
  const playSectionRef = useRef(null);
  const summaryRef = useRef(null);
  const memoryOpenIdsRef = useRef([]);
  const tapFrameRef = useRef(null);
  const tapGameRef = useRef(null);
  const counterFrameRef = useRef(null);
  const counterTickRef = useRef(0);
  const counterGameRef = useRef(null);
  const counterStageRef = useRef(null);
  const counterBinRefs = useRef({});
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [soundBlocked, setSoundBlocked] = useState(false);
  const [videoFailed, setVideoFailed] = useState(false);
  const [drinks, setDrinks] = useState([]);
  const [drinksLoading, setDrinksLoading] = useState(true);
  const [drinksError, setDrinksError] = useState('');
  const [activeGame, setActiveGame] = useState('logo-quiz');
  const [questionSet, setQuestionSet] = useState([]);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [question, setQuestion] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState('');
  const [roundResult, setRoundResult] = useState(null);
  const [score, setScore] = useState({ correct: 0, total: 0, streak: 0 });
  const [tavernStatus, setTavernStatus] = useState(null);
  const [tavernLeaderboard, setTavernLeaderboard] = useState({ items: [], loading: false, error: '' });
  const [leaderboardRefreshTick, setLeaderboardRefreshTick] = useState(0);
  const [sessionCorrect, setSessionCorrect] = useState(0);
  const [sessionKey, setSessionKey] = useState('');
  const [sessionSummary, setSessionSummary] = useState(null);
  const [rewardLoading, setRewardLoading] = useState(false);
  const [memoryDeck, setMemoryDeck] = useState([]);
  const [memoryOpenIds, setMemoryOpenIds] = useState([]);
  const [memoryMatchedPairs, setMemoryMatchedPairs] = useState([]);
  const [memoryMoves, setMemoryMoves] = useState(0);
  const [memoryLocked, setMemoryLocked] = useState(false);
  const [tapGame, setTapGame] = useState({
    status: 'idle',
    round: 1,
    fill: 0,
    scores: [],
    lastResult: null,
  });
  const [counterGame, setCounterGame] = useState({
    ...createIdleCounterGame(),
  });
  const prefersReducedMotion = useMemo(() => (
    typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ), []);
  const memoryMatchedSet = useMemo(() => new Set(memoryMatchedPairs), [memoryMatchedPairs]);
  const tavernLevel = useMemo(() => getTavernLevel(tavernStatus?.all_time?.rounds || 0), [tavernStatus]);
  const todayRoundCount = tavernStatus?.today?.rounds || 0;
  const dailyGuestComplete = todayRoundCount > 0;
  const dailyGuestProgress = dailyGuestComplete
    ? '1 / 1'
    : activeGame === 'tap-reaction'
    ? `${tapGame.scores.length} / ${TAP_REACTION_ROUNDS}`
    : activeGame === 'counter-timing'
    ? `${counterGame.index + (counterGame.items.length && counterGame.status !== 'idle' ? 1 : 0)} / ${COUNTER_TIMING_ROUNDS}`
    : activeGame === 'memory' && memoryDeck.length
    ? `${memoryMatchedPairs.length} / ${MEMORY_PAIR_COUNT}`
    : questionSet.length ? `${Math.min(questionIndex + 1, SESSION_LENGTH)} / ${SESSION_LENGTH}` : 'offen';

  useEffect(() => {
    tapGameRef.current = tapGame;
  }, [tapGame]);

  useEffect(() => {
    counterGameRef.current = counterGame;
  }, [counterGame]);

  useEffect(() => {
    const saved = loadTavernDailyState(dailyStorageKey);
    if (!saved) return;

    if (saved.score) {
      setScore((previous) => ({
        correct: Math.max(previous.correct, Number(saved.score.correct || 0)),
        total: Math.max(previous.total, Number(saved.score.total || 0)),
        streak: Math.max(previous.streak, Number(saved.score.streak || 0)),
      }));
    }
    if (Number(saved.sessionCorrect || 0) > 0) {
      setSessionCorrect((previous) => Math.max(previous, Number(saved.sessionCorrect || 0)));
    }
    if (saved.activeGame && GAME_TABLES.some((game) => game.key === saved.activeGame)) {
      setActiveGame(saved.activeGame);
    }
  }, [dailyStorageKey]);

  useEffect(() => {
    saveTavernDailyState(dailyStorageKey, {
      activeGame,
      score,
      sessionCorrect,
    });
  }, [activeGame, dailyStorageKey, score, sessionCorrect]);

  useEffect(() => {
    let alive = true;

    async function loadTavernStatus() {
      try {
        const response = await fetch(TAVERN_STATUS_URL, {
          credentials: 'include',
          cache: 'no-store',
          headers: {
            'X-WP-Nonce': window?.pfandpiratData?.nonce || '',
          },
        });
        const payload = await response.json().catch(() => null);
        if (!alive || !response.ok) return;

        const nextStatus = normalizeTavernStatus(payload);
        setTavernStatus(nextStatus);
        setScore((previous) => ({
          correct: Math.max(previous.correct, nextStatus.today.correct_count),
          total: Math.max(previous.total, nextStatus.today.total_count),
          streak: previous.streak,
        }));
      } catch (error) {
        if (alive) setTavernStatus(normalizeTavernStatus(null));
      }
    }

    loadTavernStatus();
    return () => {
      alive = false;
    };
  }, []);

  const tavernStats = useMemo(() => [
    { label: 'Tavernenruf', value: `Stufe ${tavernLevel.level}`, hint: tavernLevel.name },
    { label: 'Heute gespielt', value: formatRoundCount(todayRoundCount), hint: 'volle Tavernenrunden' },
    { label: 'Serie', value: `${score.streak} Treffer`, hint: 'aktuelle Runde' },
    { label: 'Trefferquote', value: score.total ? `${Math.round((score.correct / score.total) * 100)} %` : '0 %', hint: 'heute' },
  ], [score, tavernLevel, todayRoundCount]);

  const tavernOrders = useMemo(() => [
    {
      key: 'cola-mix',
      title: 'Drei Bilder erkennen',
      progress: `${Math.min(sessionCorrect, 3)} / 3`,
      reward: '+XP am Rundenende',
      text: 'Löse Bildfragen oder finde Kartenpaare in der Taverne.',
    },
    {
      key: 'deposit-run',
      title: 'Pfandwert-Serie',
      progress: `${Math.min(score.streak, 5)} / 5`,
      reward: 'Münzen',
      text: 'Beantworte mehrere Fragen hintereinander ohne Fehler.',
    },
    {
      key: 'daily-guest',
      title: 'Der Tagesgast',
      progress: dailyGuestProgress,
      reward: 'Bilanzkarte',
      text: dailyGuestComplete ? 'Heute schon erledigt.' : 'Spiele heute eine volle Tavernenrunde.',
    },
  ], [dailyGuestComplete, dailyGuestProgress, score.streak, sessionCorrect]);

  const activeGameConfig = GAME_TABLES.find((game) => game.key === activeGame) || GAME_TABLES[0];
  const activeGameNeedsDrinks = activeGame !== 'memory' && activeGame !== 'tap-reaction';

  useEffect(() => {
    let alive = true;

    async function loadTavernLeaderboard() {
      setTavernLeaderboard((previous) => ({ ...previous, loading: true, error: '' }));
      try {
        const url = new URL(TAVERN_LEADERBOARD_URL, window.location.origin);
        url.searchParams.set('game_key', activeGame);
        url.searchParams.set('limit', '5');
        url.searchParams.set('cb', String(Date.now()));
        const response = await fetch(url.href, {
          credentials: 'include',
          cache: 'no-store',
          headers: {
            'X-WP-Nonce': window?.pfandpiratData?.nonce || '',
          },
        });
        const payload = await response.json().catch(() => null);
        if (!alive) return;
        if (!response.ok) throw new Error(payload?.message || 'Bestenliste konnte nicht geladen werden.');
        setTavernLeaderboard({ items: normalizeTavernLeaderboard(payload), loading: false, error: '' });
      } catch (error) {
        if (alive) setTavernLeaderboard({ items: [], loading: false, error: 'Bestenliste gerade nicht verfügbar.' });
      }
    }

    loadTavernLeaderboard();
    return () => {
      alive = false;
    };
  }, [activeGame, leaderboardRefreshTick]);

  useEffect(() => {
    let alive = true;

    async function loadDrinks() {
      setDrinksLoading(true);
      setDrinksError('');
      try {
        const origin = window.location.origin;
        const topUrl = new URL(DRINKS_TOP_URL, origin);
        topUrl.searchParams.set('cb', String(Date.now()));
        let response = await fetch(topUrl.href, { credentials: 'same-origin', cache: 'no-store' });
        let payload = response.ok ? await response.json() : [];
        let list = Array.isArray(payload) ? payload : (payload?.items || []);

        if (list.length < 4) {
          const searchUrl = new URL(DRINKS_SEARCH_URL, origin);
          response = await fetch(searchUrl.href, { credentials: 'same-origin', cache: 'no-store' });
          payload = response.ok ? await response.json() : [];
          list = Array.isArray(payload) ? payload : (payload?.items || []);
        }

        const normalized = list.map(normalizeDrink).filter((drink) => drink.name);
        if (alive) setDrinks(normalized.length >= 4 ? normalized : FALLBACK_DRINKS.map(normalizeDrink));
      } catch (error) {
        if (alive) {
          setDrinks(FALLBACK_DRINKS.map(normalizeDrink));
          setDrinksError('Getränkedaten konnten nicht geladen werden. Es läuft eine kleine Demo-Auswahl.');
        }
      } finally {
        if (alive) setDrinksLoading(false);
      }
    }

    loadDrinks();
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (tapFrameRef.current) {
      window.cancelAnimationFrame(tapFrameRef.current);
    }
  }, []);

  const startRound = useCallback((mode = activeGame) => {
    if (tapFrameRef.current) {
      window.cancelAnimationFrame(tapFrameRef.current);
      tapFrameRef.current = null;
    }
    if (counterFrameRef.current) {
      window.cancelAnimationFrame(counterFrameRef.current);
      counterFrameRef.current = null;
    }
    counterTickRef.current = 0;

    if (mode === 'tap-reaction') {
      setActiveGame(mode);
      setQuestionSet([]);
      setQuestionIndex(0);
      setQuestion(null);
      setMemoryDeck([]);
      memoryOpenIdsRef.current = [];
      setMemoryOpenIds([]);
      setMemoryMatchedPairs([]);
      setMemoryMoves(0);
      setMemoryLocked(false);
      setSelectedAnswer('');
      setRoundResult(null);
      setSessionCorrect(0);
      setSessionKey(makeSessionKey(mode));
      setSessionSummary(null);
      setTapGame({
        status: 'idle',
        round: 1,
        fill: 0,
        scores: [],
        lastResult: null,
      });
      setCounterGame(createIdleCounterGame());
      window.setTimeout(() => {
        scrollElementIntoView(playSectionRef.current, prefersReducedMotion ? 'auto' : 'smooth');
      }, 80);
      return;
    }

    if (mode === 'counter-timing') {
      const nextItems = buildCounterTimingItems(drinks);
      setActiveGame(mode);
      setQuestionSet([]);
      setQuestionIndex(0);
      setQuestion(null);
      setMemoryDeck([]);
      memoryOpenIdsRef.current = [];
      setMemoryOpenIds([]);
      setMemoryMatchedPairs([]);
      setMemoryMoves(0);
      setMemoryLocked(false);
      setSelectedAnswer('');
      setRoundResult(null);
      setSessionCorrect(0);
      setSessionKey(makeSessionKey(mode));
      setSessionSummary(null);
      setTapGame({ status: 'idle', round: 1, fill: 0, scores: [], lastResult: null });
      setCounterGame({
        status: 'running',
        items: nextItems,
        index: 0,
        position: 0,
        score: 0,
        misses: 0,
        streak: 0,
        lastResult: null,
        dragPoint: null,
      });
      window.setTimeout(() => {
        scrollElementIntoView(playSectionRef.current, prefersReducedMotion ? 'auto' : 'smooth');
      }, 80);
      return;
    }

    if (mode === 'memory') {
      const nextMemoryDeck = buildMemoryDeck(MEMORY_CARDS);
      setActiveGame(mode);
      setQuestionSet([]);
      setQuestionIndex(0);
      setQuestion(null);
      setMemoryDeck(nextMemoryDeck);
      memoryOpenIdsRef.current = [];
      setMemoryOpenIds([]);
      setMemoryMatchedPairs([]);
      setMemoryMoves(0);
      setMemoryLocked(false);
      setSelectedAnswer('');
      setRoundResult(null);
      setSessionCorrect(0);
      setSessionKey(makeSessionKey(mode));
      setSessionSummary(null);
      setTapGame({ status: 'idle', round: 1, fill: 0, scores: [], lastResult: null });
      setCounterGame(createIdleCounterGame());
      window.setTimeout(() => {
        scrollElementIntoView(playSectionRef.current, prefersReducedMotion ? 'auto' : 'smooth');
      }, 80);
      return;
    }

    const nextQuestionSet = buildQuestionSet(mode, drinks);
    setActiveGame(mode);
    setQuestionSet(nextQuestionSet);
    setQuestionIndex(0);
    setQuestion(nextQuestionSet[0] || null);
    setMemoryDeck([]);
    memoryOpenIdsRef.current = [];
    setMemoryOpenIds([]);
    setMemoryMatchedPairs([]);
    setMemoryMoves(0);
    setMemoryLocked(false);
    setSelectedAnswer('');
    setRoundResult(null);
    setSessionCorrect(0);
    setSessionKey(makeSessionKey(mode));
    setSessionSummary(null);
    setTapGame({ status: 'idle', round: 1, fill: 0, scores: [], lastResult: null });
    setCounterGame(createIdleCounterGame());
    window.setTimeout(() => {
      scrollElementIntoView(playSectionRef.current, prefersReducedMotion ? 'auto' : 'smooth');
    }, 80);
  }, [activeGame, drinks, prefersReducedMotion]);

  const selectGame = useCallback((mode) => {
    startRound(mode);
  }, [startRound]);

  const finishRound = useCallback(async (correctCount, totalCount = SESSION_LENGTH) => {
    const summary = buildRewardSummary(correctCount, totalCount);
    const claimSessionKey = sessionKey || makeSessionKey(activeGame);
    setSessionSummary({ ...summary, awardedXp: 0, awardedBronze: 0, rewardStatus: 'pending' });
    setQuestion(null);
    setSelectedAnswer('');
    setRoundResult(null);
    setRewardLoading(true);

    try {
      const response = await fetch(TAVERN_REWARD_URL, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': window?.pfandpiratData?.nonce || '',
        },
        body: JSON.stringify({
          session_key: claimSessionKey,
          game_key: activeGame,
          correct: summary.correct,
          total: summary.total,
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload?.message || 'Belohnung konnte nicht gutgeschrieben werden.');
      }
      if (payload?.session_patch && mergeSessionPatch) {
        mergeSessionPatch(payload.session_patch);
      }
      if (payload?.tavern_status) {
        const nextStatus = normalizeTavernStatus(payload.tavern_status);
        setTavernStatus(nextStatus);
        setScore((previous) => ({
          correct: Math.max(previous.correct, nextStatus.today.correct_count),
          total: Math.max(previous.total, nextStatus.today.total_count),
          streak: previous.streak,
        }));
      }
      if (typeof applyGamificationPayload === 'function') {
        applyGamificationPayload(payload, {
          emitXpToast: true,
          event: payload?.event || 'tavern_game_complete',
          awarded: Number(payload?.awarded || 0),
          toastLabel: 'Tavernenrunde abgeschlossen',
        });
      }
      setSessionSummary({
        ...summary,
        awardedXp: Number(payload?.awarded || 0),
        awardedBronze: Number(payload?.bronze_awarded || 0),
        bronzeLabel: Number(payload?.bronze_awarded || 0) > 0 ? `+${Number(payload.bronze_awarded)} Bronze` : 'keine Münzen',
        couponLabel: payload?.coupon?.label || summary.couponLabel,
        couponAwarded: Boolean(payload?.coupon?.awarded),
        couponTitle: payload?.coupon?.title || '',
        couponShop: payload?.coupon?.shop_name || '',
        couponCategory: payload?.coupon?.category || '',
        couponLogoUrl: payload?.coupon?.logo_url || '',
        couponUrl: payload?.coupon?.deeplink_url || '',
        rewardStatus: payload?.already_claimed ? 'already_claimed' : 'claimed',
      });
      setLeaderboardRefreshTick((value) => value + 1);
    } catch (error) {
      setSessionSummary({ ...summary, awardedXp: 0, awardedBronze: 0, rewardStatus: 'failed' });
    } finally {
      setRewardLoading(false);
    }
  }, [activeGame, applyGamificationPayload, mergeSessionPatch, sessionKey]);

  const finishTapAttempt = useCallback((fillPercent) => {
    if (tapFrameRef.current) {
      window.cancelAnimationFrame(tapFrameRef.current);
      tapFrameRef.current = null;
    }

    const current = tapGameRef.current || tapGame;
    if (current.status !== 'pouring') return;

    const result = getTapReactionScore(fillPercent);
    const nextScores = [...current.scores, result.points];
    const correctCount = getTapRewardCorrectCount(nextScores);

    setTapGame({
      status: 'result',
      round: current.round,
      fill: result.fill,
      scores: nextScores,
      lastResult: result,
    });
    setSessionCorrect(correctCount);
    setScore((previous) => ({
      correct: previous.correct + (result.points >= 70 ? 1 : 0),
      total: previous.total + 1,
      streak: result.points >= 70 ? previous.streak + 1 : 0,
    }));

    if (nextScores.length >= TAP_REACTION_ROUNDS) {
      window.setTimeout(() => finishRound(correctCount, TAP_REACTION_ROUNDS), 900);
    }
  }, [finishRound, tapGame]);

  const beginTapPour = useCallback(() => {
    const current = tapGameRef.current || tapGame;
    if (current.status === 'pouring' || current.scores.length >= TAP_REACTION_ROUNDS || rewardLoading || sessionSummary) return;

    if (tapFrameRef.current) {
      window.cancelAnimationFrame(tapFrameRef.current);
      tapFrameRef.current = null;
    }

    const nextRound = current.scores.length + 1;
    const speed = 38 + (Math.random() * 13) + (current.scores.length * 1.5);
    const startTime = window.performance.now();

    setTapGame({
      status: 'pouring',
      round: nextRound,
      fill: 0,
      scores: current.scores,
      lastResult: null,
    });

    const tick = (now) => {
      const fill = ((now - startTime) / 1000) * speed;
      if (fill >= TAP_OVERFLOW_PERCENT) {
        finishTapAttempt(TAP_OVERFLOW_PERCENT);
        return;
      }

      setTapGame((previous) => ({ ...previous, fill }));
      tapFrameRef.current = window.requestAnimationFrame(tick);
    };

    tapFrameRef.current = window.requestAnimationFrame(tick);
  }, [finishTapAttempt, rewardLoading, sessionSummary, tapGame]);

  const stopTapPour = useCallback(() => {
    const current = tapGameRef.current || tapGame;
    if (current.status !== 'pouring') return;
    finishTapAttempt(current.fill);
  }, [finishTapAttempt, tapGame]);

  const resolveCounterDrop = useCallback((targetKey) => {
    if (counterFrameRef.current) {
      window.cancelAnimationFrame(counterFrameRef.current);
      counterFrameRef.current = null;
    }
    counterTickRef.current = 0;

    const current = counterGameRef.current;
    if (!current || !['running', 'dragging'].includes(current.status) || rewardLoading || sessionSummary) return;

    const item = current.items[current.index];
    if (!item) return;

    const isCorrect = targetKey === item.target;
    const nextScore = current.score + (isCorrect ? 1 : 0);
    const nextMisses = current.misses + (isCorrect ? 0 : 1);
    const nextStreak = isCorrect ? current.streak + 1 : 0;
    const isLastItem = current.index + 1 >= current.items.length;
    const targetLabel = COUNTER_TIMING_BINS.find((bin) => bin.key === item.target)?.title || item.target;
    const result = {
      correct: isCorrect,
      title: isCorrect ? 'Sauber sortiert' : targetKey ? 'Falsches Fach' : 'Vom Tresen gerutscht',
      text: isCorrect
        ? `${item.name} landet genau richtig.`
        : `${item.name} gehört in ${targetLabel}.`,
    };

    setSessionCorrect(nextScore);
    setScore((previous) => ({
      correct: previous.correct + (isCorrect ? 1 : 0),
      total: previous.total + 1,
      streak: isCorrect ? previous.streak + 1 : 0,
    }));
    setRoundResult({ correct: isCorrect, text: result.text });
    setCounterGame({
      ...current,
      status: 'feedback',
      position: Math.min(current.position, 100),
      score: nextScore,
      misses: nextMisses,
      streak: nextStreak,
      lastResult: result,
      dragPoint: null,
    });

    if (isLastItem) {
      window.setTimeout(() => finishRound(nextScore, COUNTER_TIMING_ROUNDS), 850);
      return;
    }

    window.setTimeout(() => {
      setRoundResult(null);
      setCounterGame((previous) => ({
        ...(previous.status === 'feedback' && previous.items.length
          ? {
            ...previous,
            status: 'running',
            index: previous.index + 1,
            position: 0,
            lastResult: null,
            dragPoint: null,
          }
          : previous),
      }));
    }, 720);
  }, [finishRound, rewardLoading, sessionSummary]);

  useEffect(() => {
    if (activeGame !== 'counter-timing' || counterGame.status !== 'running' || rewardLoading || sessionSummary) {
      if (counterFrameRef.current) {
        window.cancelAnimationFrame(counterFrameRef.current);
        counterFrameRef.current = null;
      }
      counterTickRef.current = 0;
      return undefined;
    }

    const tick = (now) => {
      const current = counterGameRef.current;
      if (!current || current.status !== 'running') return;

      const lastTick = counterTickRef.current || now;
      const delta = Math.min(80, now - lastTick);
      counterTickRef.current = now;
      const speed = (prefersReducedMotion ? 18 : 25) + (current.index * 1.6);
      const nextPosition = current.position + ((delta / 1000) * speed);

      if (nextPosition >= COUNTER_TIMING_MISS_POSITION) {
        resolveCounterDrop(null);
        return;
      }

      setCounterGame((previous) => (
        previous.status === 'running'
          ? { ...previous, position: nextPosition }
          : previous
      ));
      counterFrameRef.current = window.requestAnimationFrame(tick);
    };

    counterFrameRef.current = window.requestAnimationFrame(tick);

    return () => {
      if (counterFrameRef.current) {
        window.cancelAnimationFrame(counterFrameRef.current);
        counterFrameRef.current = null;
      }
      counterTickRef.current = 0;
    };
  }, [activeGame, counterGame.index, counterGame.status, prefersReducedMotion, resolveCounterDrop, rewardLoading, sessionSummary]);

  const updateCounterDragPoint = useCallback((event) => {
    const stage = counterStageRef.current;
    if (!stage) return null;
    const rect = stage.getBoundingClientRect();
    return {
      x: Math.max(32, Math.min(rect.width - 32, event.clientX - rect.left)),
      y: Math.max(36, Math.min(rect.height - 36, event.clientY - rect.top)),
    };
  }, []);

  const beginCounterDrag = useCallback((event) => {
    const current = counterGameRef.current;
    if (!current || current.status !== 'running' || rewardLoading || sessionSummary) return;

    event.preventDefault();
    try {
      event.currentTarget.setPointerCapture(event.pointerId);
    } catch {}
    if (counterFrameRef.current) {
      window.cancelAnimationFrame(counterFrameRef.current);
      counterFrameRef.current = null;
    }
    counterTickRef.current = 0;
    const dragPoint = updateCounterDragPoint(event);
    setCounterGame((previous) => ({
      ...previous,
      status: 'dragging',
      dragPoint,
    }));
  }, [rewardLoading, sessionSummary, updateCounterDragPoint]);

  const moveCounterDrag = useCallback((event) => {
    const current = counterGameRef.current;
    if (!current || current.status !== 'dragging') return;

    event.preventDefault();
    const dragPoint = updateCounterDragPoint(event);
    setCounterGame((previous) => ({ ...previous, dragPoint }));
  }, [updateCounterDragPoint]);

  const endCounterDrag = useCallback((event) => {
    const current = counterGameRef.current;
    if (!current || current.status !== 'dragging') return;

    event.preventDefault();
    try {
      event.currentTarget.releasePointerCapture(event.pointerId);
    } catch {}

    const targetKey = COUNTER_TIMING_BINS.find((bin) => {
      const element = counterBinRefs.current[bin.key];
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return (
        event.clientX >= rect.left
        && event.clientX <= rect.right
        && event.clientY >= rect.top
        && event.clientY <= rect.bottom
      );
    })?.key || null;

    resolveCounterDrop(targetKey);
  }, [resolveCounterDrop]);

  const handleMemoryCardClick = useCallback((cardId) => {
    const currentOpenIds = memoryOpenIdsRef.current;
    if (memoryLocked || sessionSummary || rewardLoading || currentOpenIds.includes(cardId)) return;
    const clickedCard = memoryDeck.find((card) => card.id === cardId);
    if (!clickedCard || memoryMatchedSet.has(clickedCard.pairId)) return;

    const nextOpenIds = [...currentOpenIds, cardId];
    memoryOpenIdsRef.current = nextOpenIds;
    setMemoryOpenIds(nextOpenIds);

    if (nextOpenIds.length < 2) return;

    const firstCard = memoryDeck.find((card) => card.id === nextOpenIds[0]);
    const secondCard = memoryDeck.find((card) => card.id === nextOpenIds[1]);
    if (!firstCard || !secondCard) {
      setMemoryOpenIds([]);
      return;
    }

    setMemoryLocked(true);
    setMemoryMoves((previous) => previous + 1);

    if (firstCard.pairId === secondCard.pairId) {
      const nextMatchedPairs = [...memoryMatchedPairs, firstCard.pairId];
      setMemoryMatchedPairs(nextMatchedPairs);
      setSessionCorrect(nextMatchedPairs.length);
      setScore((previous) => ({
        correct: previous.correct + 1,
        total: previous.total + 1,
        streak: previous.streak + 1,
      }));
      setRoundResult({ correct: true, text: 'Paar gefunden. Der Wirt legt die Karten zur Seite.' });

      window.setTimeout(() => {
        memoryOpenIdsRef.current = [];
        setMemoryOpenIds([]);
        setMemoryLocked(false);
        setRoundResult(null);
        if (nextMatchedPairs.length >= MEMORY_PAIR_COUNT) {
          finishRound(nextMatchedPairs.length, MEMORY_PAIR_COUNT);
        }
      }, 650);
      return;
    }

    setScore((previous) => ({
      correct: previous.correct,
      total: previous.total + 1,
      streak: 0,
    }));
    setRoundResult({ correct: false, text: 'Nicht dasselbe Motiv. Die Karten drehen sich gleich wieder um.' });

    window.setTimeout(() => {
      memoryOpenIdsRef.current = [];
      setMemoryOpenIds([]);
      setMemoryLocked(false);
      setRoundResult(null);
    }, 1000);
  }, [finishRound, memoryDeck, memoryLocked, memoryMatchedPairs, memoryMatchedSet, rewardLoading, sessionSummary]);

  useEffect(() => {
    if (!sessionSummary) return undefined;

    const timer = window.setTimeout(() => {
      scrollElementIntoView(summaryRef.current || playSectionRef.current, prefersReducedMotion ? 'auto' : 'smooth');
      try {
        summaryRef.current?.focus?.({ preventScroll: true });
      } catch {}
    }, 80);

    return () => window.clearTimeout(timer);
  }, [prefersReducedMotion, sessionSummary?.correct, sessionSummary?.total]);

  const answerQuestion = useCallback((answer) => {
    if (!question || roundResult) return;
    const isCorrect = answer === question.answer;
    const nextSessionCorrect = sessionCorrect + (isCorrect ? 1 : 0);
    const isLastQuestion = questionIndex + 1 >= questionSet.length;
    setSelectedAnswer(answer);
    setRoundResult({ correct: isCorrect, text: resultText(isCorrect, question.answer) });
    if (isCorrect) {
      setSessionCorrect((previous) => previous + 1);
    }
    setScore((previous) => ({
      correct: previous.correct + (isCorrect ? 1 : 0),
      total: previous.total + 1,
      streak: isCorrect ? previous.streak + 1 : 0,
    }));
    if (isLastQuestion) {
      window.setTimeout(() => finishRound(nextSessionCorrect), 650);
    }
  }, [finishRound, question, questionIndex, questionSet.length, roundResult, sessionCorrect]);

  const goToNextQuestion = useCallback(() => {
    const nextIndex = questionIndex + 1;
    const nextQuestion = questionSet[nextIndex] || null;
    setQuestionIndex(nextIndex);
    setQuestion(nextQuestion);
    setSelectedAnswer('');
    setRoundResult(null);
  }, [questionIndex, questionSet]);

  const toggleTavernSound = useCallback(async () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (soundEnabled) {
      audio.pause();
      setSoundEnabled(false);
      return;
    }

    try {
      audio.volume = 0.28;
      audio.loop = true;
      await audio.play();
      setSoundBlocked(false);
      setSoundEnabled(true);
    } catch (error) {
      setSoundBlocked(true);
      setSoundEnabled(false);
    }
  }, [soundEnabled]);

  const currentCounterItem = counterGame.items[counterGame.index] || null;
  const counterProgressLabel = counterGame.items.length
    ? `${Math.min(counterGame.index + 1, counterGame.items.length)} / ${counterGame.items.length}`
    : `0 / ${COUNTER_TIMING_ROUNDS}`;
  const counterDrinkStyle = counterGame.status === 'dragging' && counterGame.dragPoint
    ? {
      left: `${counterGame.dragPoint.x}px`,
      top: `${counterGame.dragPoint.y}px`,
      transform: 'translate(-50%, -50%) rotate(-4deg) scale(1.05)',
    }
    : {
      left: `${Math.min(100, Math.max(0, counterGame.position))}%`,
    };

  return (
    <main className="pfp-tavern-page">
      <div className="pfp-tavern-shell">
        <button type="button" className="pfp-tavern-back" onClick={() => navigate('/freibeuterhafen')}>
          Zurück zum Hafen
        </button>

        <section className="pfp-tavern-hero">
          <audio ref={audioRef} src={TAVERN_SOUND_URL} preload="none" loop />
          {!prefersReducedMotion && !videoFailed ? (
            <video
              className="pfp-tavern-hero__video"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              onError={() => setVideoFailed(true)}
            >
              <source src={TAVERN_VIDEO_URL} type="video/mp4" />
            </video>
          ) : (
            <div className="pfp-tavern-hero__fallback" aria-hidden="true" />
          )}
          <div className="pfp-tavern-hero__shade" aria-hidden="true" />
          <button
            type="button"
            className={`pfp-tavern-sound-toggle ${soundEnabled ? 'is-active' : ''}`}
            onClick={toggleTavernSound}
            aria-pressed={soundEnabled}
          >
            {soundEnabled ? 'Tavernenmusik läuft' : 'Tavernenmusik starten'}
          </button>
          <div className="pfp-tavern-hero__copy">
            <h1>Deine Taverne</h1>
            {soundBlocked ? (
              <small className="pfp-tavern-sound-note">Ton wurde blockiert. Bitte tippe den Musikknopf erneut an.</small>
            ) : null}
          </div>
          <aside className="pfp-tavern-player">
            <span>Stammgast</span>
            <strong>{displayName}</strong>
            <em>{drinksLoading ? 'Der Wirt sortiert die Karten.' : `${drinks.length} Getränke am Tresen.`}</em>
          </aside>
        </section>

        <section className="pfp-tavern-stats" aria-label="Tavernenstatus">
          {tavernStats.map((stat) => (
            <div key={stat.label} className="pfp-tavern-stat">
              <span>{stat.label}</span>
              <strong>{stat.value}</strong>
              <em>{stat.hint}</em>
            </div>
          ))}
        </section>

        <section className="pfp-tavern-layout">
          <div className="pfp-tavern-main">
            <div className="pfp-tavern-section-head">
              <span className="pfp-harbor-kicker">Spieltische</span>
              <h2>Minispiele</h2>
            </div>

            <div className="pfp-tavern-game-grid">
              {GAME_TABLES.map((game) => (
                <article key={game.key} className={`pfp-tavern-game ${activeGame === game.key ? 'is-active' : ''}`}>
                  <div className="pfp-tavern-game__top">
                    <span>{game.meta}</span>
                    <em>{game.state}</em>
                  </div>
                  <h3>{game.title}</h3>
                  <strong>{game.label}</strong>
                  <p>{game.description}</p>
                  <button type="button" disabled={game.key !== 'memory' && game.key !== 'tap-reaction' && drinksLoading} onClick={() => selectGame(game.key)}>
                    {game.key === 'tap-reaction'
                      ? activeGame === game.key && tapGame.scores.length ? 'Neu zapfen' : 'Zapfen spielen'
                      : game.key === 'counter-timing'
                      ? activeGame === game.key && counterGame.items.length ? 'Neue Schicht' : 'Tresen spielen'
                      : game.key === 'memory'
                      ? activeGame === game.key && memoryDeck.length ? 'Neu mischen' : 'Memory spielen'
                      : activeGame === game.key && question ? 'Neue 10er-Runde' : '10er-Runde spielen'}
                  </button>
                </article>
              ))}
            </div>

            <section ref={playSectionRef} className="pfp-tavern-play" aria-live="polite">
              <div className="pfp-tavern-play__head">
                <div>
                  <span className="pfp-harbor-kicker">{activeGameConfig.meta}</span>
                  <h2>{activeGameConfig.title}</h2>
                </div>
                <button type="button" disabled={activeGameNeedsDrinks && drinksLoading} onClick={() => startRound()}>
                  {activeGame === 'tap-reaction'
                    ? 'Zapfrunde vorbereiten'
                    : activeGame === 'counter-timing'
                    ? 'Tresen vorbereiten'
                    : activeGame === 'memory'
                    ? 'Memory mischen'
                    : '10er-Runde starten'}
                </button>
              </div>

              {activeGameNeedsDrinks && drinksError ? <p className="pfp-tavern-play__notice">{drinksError}</p> : null}
              {activeGameNeedsDrinks && drinksLoading ? <div className="pfp-tavern-play__empty">Getränkekarten werden gemischt...</div> : null}

              {activeGame !== 'tap-reaction' && (!activeGameNeedsDrinks || !drinksLoading) && !question && !memoryDeck.length && !counterGame.items.length && !sessionSummary ? (
                <div className="pfp-tavern-play__empty">
                  {activeGame === 'counter-timing'
                    ? `Starte eine Sortierschicht mit ${COUNTER_TIMING_ROUNDS} rutschenden Getränken.`
                    : activeGame === 'memory'
                    ? `Starte eine Runde mit ${MEMORY_PAIR_COUNT} Paaren.`
                    : 'Starte eine 10er-Runde.'}
                </div>
              ) : null}

              {sessionSummary ? (
                <section
                  ref={summaryRef}
                  className="pfp-tavern-summary-card"
                  tabIndex="-1"
                  aria-label="Tavernenrunde beendet und Belohnung"
                >
                  <div className="pfp-tavern-summary-card__score">
                    <span>{sessionSummary.percent}%</span>
                    <strong>{sessionSummary.correct} / {sessionSummary.total} richtig</strong>
                  </div>
                  <div className="pfp-tavern-summary-card__body">
                    <span className="pfp-harbor-kicker">Runde beendet</span>
                    <h3>{sessionSummary.title}</h3>
                    <div className="pfp-tavern-summary-card__rewards">
                      <span>{rewardLoading ? 'XP wird gutgeschrieben...' : `+${sessionSummary.awardedXp || sessionSummary.xp} XP`}</span>
                      <span>{sessionSummary.bronzeLabel}</span>
                      {sessionSummary.couponAwarded ? <span>{sessionSummary.couponLabel}</span> : null}
                    </div>
                    {sessionSummary.couponAwarded ? (
                      <div className="pfp-tavern-coupon-win">
                        {sessionSummary.couponLogoUrl ? <img src={sessionSummary.couponLogoUrl} alt="" loading="lazy" /> : null}
                        <div>
                          <span>Coupon gewonnen</span>
                          <strong>{sessionSummary.couponTitle || sessionSummary.couponLabel}</strong>
                          <em>{[sessionSummary.couponShop, sessionSummary.couponCategory].filter(Boolean).join(' · ')}</em>
                        </div>
                        {sessionSummary.couponUrl ? (
                          <a href={sessionSummary.couponUrl} target="_blank" rel="noopener noreferrer">Zum Angebot</a>
                        ) : null}
                      </div>
                    ) : null}
                    {sessionSummary.rewardStatus === 'already_claimed' ? (
                      <em>Diese Runde war bereits gutgeschrieben. Es wurde keine doppelte Belohnung gebucht.</em>
                    ) : null}
                    {sessionSummary.rewardStatus === 'failed' ? (
                      <em>Belohnungen konnten gerade nicht gutgeschrieben werden. Bitte versuche die Runde später erneut.</em>
                    ) : null}
                    <button type="button" onClick={() => startRound(activeGame)}>
                      {activeGame === 'tap-reaction'
                        ? 'Neue Zapfrunde starten'
                        : activeGame === 'counter-timing'
                        ? 'Neue Tresenschicht starten'
                        : activeGame === 'memory'
                        ? 'Neues Memory starten'
                        : 'Neue 10er-Runde starten'}
                    </button>
                  </div>
                </section>
              ) : null}

              {activeGame === 'counter-timing' && counterGame.items.length && !sessionSummary ? (
                <div className={`pfp-tavern-counter-game is-${counterGame.status}`}>
                  <div className="pfp-tavern-counter-game__stage-wrap">
                    <div className="pfp-tavern-counter-game__status">
                      <span>Getränk {counterProgressLabel}</span>
                      <strong>{counterGame.score} Treffer</strong>
                      <em>{counterGame.misses} daneben</em>
                    </div>
                    <div ref={counterStageRef} className="pfp-tavern-counter-stage" aria-label="Rutschender Tresen">
                      <div className="pfp-tavern-counter-stage__backbar" aria-hidden="true" />
                      <div className="pfp-tavern-counter-stage__rail" aria-hidden="true" />
                      <div className="pfp-tavern-counter-stage__drop" aria-hidden="true">Ende</div>
                      {currentCounterItem ? (
                        <button
                          type="button"
                          className={`pfp-tavern-counter-drink is-${currentCounterItem.visual}`}
                          style={counterDrinkStyle}
                          onPointerDown={beginCounterDrag}
                          onPointerMove={moveCounterDrag}
                          onPointerUp={endCounterDrag}
                          onPointerCancel={() => resolveCounterDrop(null)}
                          disabled={counterGame.status === 'feedback' || rewardLoading}
                          aria-label={`${currentCounterItem.name} greifen und sortieren`}
                        >
                          <CounterDrinkSprite visual={currentCounterItem.visual} image={currentCounterItem.image} name={currentCounterItem.name} />
                          <span className="pfp-tavern-counter-drink__label">
                            <strong>{currentCounterItem.name}</strong>
                            <em>{currentCounterItem.volume ? `${currentCounterItem.volume} l` : 'Getränk'}</em>
                          </span>
                        </button>
                      ) : null}
                    </div>

                    {counterGame.lastResult ? (
                      <div className={`pfp-tavern-result ${counterGame.lastResult.correct ? 'is-correct' : 'is-wrong'}`}>
                        <strong>{counterGame.lastResult.title}</strong>
                        <span>{counterGame.lastResult.text}</span>
                      </div>
                    ) : (
                      <p className="pfp-tavern-counter-game__hint">Greife das Getränk, bevor es rechts vom Tresen rutscht, und lass es auf dem passenden Ziel los.</p>
                    )}
                  </div>

                  <div className="pfp-tavern-counter-bins" aria-label="Sortierziele">
                    {COUNTER_TIMING_BINS.map((bin) => (
                      <button
                        key={bin.key}
                        type="button"
                        ref={(element) => {
                          counterBinRefs.current[bin.key] = element;
                        }}
                        className={`pfp-tavern-counter-bin is-${bin.tone}`}
                        onClick={() => resolveCounterDrop(bin.key)}
                        disabled={!['running', 'dragging'].includes(counterGame.status) || rewardLoading}
                      >
                        <CounterBinIcon tone={bin.tone} />
                        <span>{bin.title}</span>
                        <strong>{bin.hint}</strong>
                      </button>
                    ))}
                  </div>
                </div>
              ) : null}

              {activeGame === 'tap-reaction' && !sessionSummary ? (
                <div className={`pfp-tavern-tap-game is-${tapGame.status}`}>
                  <div className="pfp-tavern-tap-game__stage">
                    <img src={tapReactionArt} alt="" className="pfp-tavern-tap-game__art" loading="eager" />
                    <div className="pfp-tavern-tap-game__glass" aria-hidden="true">
                      <span className="pfp-tavern-tap-game__target" style={{ bottom: `${TAP_TARGET_PERCENT}%` }} />
                      <span
                        className="pfp-tavern-tap-game__fill"
                        style={{ height: `${Math.min(100, Math.max(0, tapGame.fill))}%` }}
                      />
                      {tapGame.status === 'pouring' || tapGame.fill >= 96 ? (
                        <span className="pfp-tavern-tap-game__foam" style={{ bottom: `${Math.min(98, Math.max(2, tapGame.fill))}%` }} />
                      ) : null}
                    </div>
                    <div className="pfp-tavern-tap-game__stream" aria-hidden="true" />
                  </div>

                  <div className="pfp-tavern-tap-game__panel">
                    <div className="pfp-tavern-tap-game__meter">
                      <span>Krug {Math.min(tapGame.scores.length + (tapGame.status === 'result' ? 0 : 1), TAP_REACTION_ROUNDS)} / {TAP_REACTION_ROUNDS}</span>
                      <strong>{tapGame.scores.reduce((sum, value) => sum + value, 0)} Punkte</strong>
                    </div>
                    <div className="pfp-tavern-tap-game__score-row" aria-label="Zapfversuche">
                      {Array.from({ length: TAP_REACTION_ROUNDS }).map((_, index) => (
                        <span key={index} className={tapGame.scores[index] >= 70 ? 'is-good' : tapGame.scores[index] === 0 ? 'is-empty' : ''}>
                          {tapGame.scores[index] ?? '-'}
                        </span>
                      ))}
                    </div>

                    {tapGame.lastResult ? (
                      <div className={`pfp-tavern-tap-game__result ${tapGame.lastResult.overflowed ? 'is-overflow' : ''}`}>
                        <strong>{tapGame.lastResult.title}</strong>
                        <span>{tapGame.lastResult.points} Punkte - {tapGame.lastResult.text}</span>
                      </div>
                    ) : (
                      <p>Halte den Blick auf die Linie und stoppe, bevor die Schaumkrone über den Rand steigt.</p>
                    )}

                    {tapGame.status === 'pouring' ? (
                      <button type="button" className="pfp-tavern-tap-game__stop" onClick={stopTapPour}>
                        Stopp!
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="pfp-tavern-tap-game__start"
                        onClick={beginTapPour}
                        disabled={rewardLoading || tapGame.scores.length >= TAP_REACTION_ROUNDS}
                      >
                        {tapGame.scores.length ? 'Nächster Krug' : 'Zapfhahn öffnen'}
                      </button>
                    )}
                  </div>
                </div>
              ) : null}

              {memoryDeck.length && !sessionSummary ? (
                <div className="pfp-tavern-memory">
                  <div className="pfp-tavern-memory__status">
                    <span>Paare {memoryMatchedPairs.length} / {MEMORY_PAIR_COUNT}</span>
                    <strong>{memoryMoves} Züge</strong>
                  </div>
                  <div className="pfp-tavern-memory-grid">
                    {memoryDeck.map((card) => {
                      const isOpen = memoryOpenIds.includes(card.id);
                      const isMatched = memoryMatchedSet.has(card.pairId);
                      return (
                        <button
                          key={card.id}
                          type="button"
                          className={`pfp-tavern-memory-card ${isOpen ? 'is-open' : ''} ${isMatched ? 'is-matched' : ''}`}
                          disabled={memoryLocked || isMatched}
                          aria-label={isOpen || isMatched ? card.title : 'Verdeckte Memorykarte aufdecken'}
                          onClick={() => handleMemoryCardClick(card.id)}
                        >
                          <span className="pfp-tavern-memory-card__inner">
                            <span className="pfp-tavern-memory-card__face pfp-tavern-memory-card__back" aria-hidden="true">
                              <strong>Pfandpirat</strong>
                              <em>Memory</em>
                            </span>
                            <span className="pfp-tavern-memory-card__face pfp-tavern-memory-card__front">
                              <img src={card.image} alt="" loading="eager" />
                              <span>{card.typeLabel}</span>
                              <strong>{card.title}</strong>
                            </span>
                          </span>
                        </button>
                      );
                    })}
                  </div>
                  {roundResult ? (
                    <div className={`pfp-tavern-result ${roundResult.correct ? 'is-correct' : 'is-wrong'}`}>
                      <strong>{roundResult.correct ? '+1 Paar' : 'Weiter merken'}</strong>
                      <span>{roundResult.text}</span>
                    </div>
                  ) : null}
                </div>
              ) : null}

              {question ? (
                <div className={`pfp-tavern-question mode-${question.mode}`}>
                  <div className="pfp-tavern-question__visual">
                    {question.mode === 'deposit-guess' ? (
                      <div className="pfp-tavern-pfand-card">
                        <span>Pfandfrage</span>
                        <strong>{question.correct.name}</strong>
                        <em>{question.correct.volume ? `${question.correct.volume} l` : 'Volumen offen'}</em>
                      </div>
                    ) : (
                      <img
                        src={question.correct.image}
                        alt=""
                        className={question.mode === 'bottle-shadow' ? 'is-shadow' : 'is-logo-quiz'}
                        loading="lazy"
                      />
                    )}
                  </div>
                  <div className="pfp-tavern-question__body">
                    <div className="pfp-tavern-question__progress">
                      Frage {Math.min(questionIndex + 1, SESSION_LENGTH)} / {SESSION_LENGTH}
                      <strong>{sessionCorrect} richtig in dieser Runde</strong>
                    </div>
                    <h3>
                      {question.mode === 'deposit-guess'
                        ? 'Welche Pfandart passt?'
                        : 'Welches Getränk erkennst du?'}
                    </h3>
                    <div className="pfp-tavern-answer-grid">
                      {question.options.map((option) => {
                        const isPicked = selectedAnswer === option;
                        const isCorrect = roundResult && option === question.answer;
                        const isWrong = roundResult && isPicked && option !== question.answer;
                        return (
                          <button
                            key={option}
                            type="button"
                            className={`${isCorrect ? 'is-correct' : ''} ${isWrong ? 'is-wrong' : ''}`}
                            disabled={Boolean(roundResult)}
                            onClick={() => answerQuestion(option)}
                          >
                            {option}
                          </button>
                        );
                      })}
                    </div>
                    {roundResult ? (
                      <div className={`pfp-tavern-result ${roundResult.correct ? 'is-correct' : 'is-wrong'}`}>
                        <strong>{roundResult.correct ? '+1 Treffer' : 'Noch kein Treffer'}</strong>
                        <span>{roundResult.text}</span>
                        {questionIndex + 1 < questionSet.length ? (
                          <button type="button" onClick={goToNextQuestion}>Nächste Frage</button>
                        ) : (
                          <span>Runde wird ausgewertet...</span>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </section>
          </div>

          <aside className="pfp-tavern-board">
            <div className="pfp-tavern-section-head">
              <span className="pfp-harbor-kicker">Auftragstafel</span>
              <h2>Persönliche Aufgaben</h2>
            </div>
            <div className="pfp-tavern-order-list">
              {tavernOrders.map((order) => (
                <article key={order.key} className="pfp-tavern-order">
                  <div>
                    <h3>{order.title}</h3>
                    <p>{order.text}</p>
                  </div>
                  <div className="pfp-tavern-order__meta">
                    <span>{order.progress}</span>
                    <strong>{order.reward}</strong>
                  </div>
                </article>
              ))}
            </div>
            <section className="pfp-tavern-highscore" aria-label={`Bestenliste ${activeGameConfig.title}`}>
              <div className="pfp-tavern-highscore__head">
                <span>Bestenliste</span>
                <strong>{activeGameConfig.title}</strong>
              </div>
              {tavernLeaderboard.loading ? (
                <div className="pfp-tavern-highscore__state">Wird geladen...</div>
              ) : tavernLeaderboard.error ? (
                <div className="pfp-tavern-highscore__state">{tavernLeaderboard.error}</div>
              ) : tavernLeaderboard.items.length ? (
                <ol className="pfp-tavern-highscore__list">
                  {tavernLeaderboard.items.map((item) => {
                    const href = getTavernProfileHref(item);
                    const rankTitle = item.gamification_rank?.title || `Level ${item.level || 0}`;
                    const ruf = item.tavern_ruf ? `Stufe ${item.tavern_ruf.level}: ${item.tavern_ruf.name}` : 'Tavernenruf offen';
                    const identity = (
                      <>
                        <img src={item.avatar_url || 'https://app.pfandpirat.com/wp-content/uploads/Pfandpirat-7.jpg'} alt="" loading="lazy" />
                        <span>
                          <strong>{item.display_name}</strong>
                          <em>{rankTitle} · {ruf}</em>
                        </span>
                      </>
                    );

                    return (
                      <li key={`${item.user_id}-${item.rank}`} className={item.is_me ? 'is-me' : ''}>
                        <b>#{item.rank}</b>
                        {href ? <a href={href}>{identity}</a> : <span className="pfp-tavern-highscore__identity">{identity}</span>}
                        <span className="pfp-tavern-highscore__score">
                          <strong>{item.score} %</strong>
                          <em>{item.best_correct} / {item.best_total} · {formatRoundCount(item.rounds)}</em>
                        </span>
                      </li>
                    );
                  })}
                </ol>
              ) : (
                <div className="pfp-tavern-highscore__state">Noch keine volle Runde gespielt.</div>
              )}
            </section>
          </aside>
        </section>

      </div>
    </main>
  );
}
